import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import theme from '../../theme';

const EditButton = ({ onToggle }) => {
  return (
    <IconButton
      disableRipple
      onClick={onToggle}
      aria-label="toggle edit"
      sx={{
        width: { xs: 32, md: 40 },
        height: { xs: 32, md: 40 },
        p: 1,
        border: `1px solid ${theme.palette.grey.line}`,
        borderRadius: 1,
      }}
    >
      <EditIcon
        sx={{
          width: { xs: 16, md: 24 },
          height: { xs: 16, md: 24 },
        }}
      />
    </IconButton>
  );
};

export default EditButton;
